import { lazy, Suspense, useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";

const ReferralCapture = () => {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref && /^[a-zA-Z0-9_-]{1,100}$/.test(ref)) {
      localStorage.setItem("referralSlug", ref);
    }
  }, [searchParams]);
  return null;
};

import Landing from "./pages/Landing";
const ChooseType = lazy(() => import("./pages/ChooseType"));
const SelectLivestock = lazy(() => import("./pages/SelectLivestock"));
const Checkout = lazy(() => import("./pages/Checkout"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const Tracker = lazy(() => import("./pages/Tracker"));
const Review = lazy(() => import("./pages/Review"));
const NotFound = lazy(() => import("./pages/NotFound"));
const PosterGenerator = lazy(() => import("./pages/PosterGenerator"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner position="bottom-center" swipeDirections={["left", "right"]} />
      <BrowserRouter>
        <ReferralCapture />
        <div className="relative min-h-screen bg-background">
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/choose-type" element={<ChooseType />} />
              <Route path="/select-livestock" element={<SelectLivestock />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/track/:trackingCode" element={<Tracker />} />
              <Route path="/review/:trackingCode" element={<Review />} />
              <Route path="/poster" element={<PosterGenerator />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
